// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LogoutSquareOutlinedSvg from "@fishx/icons-svg/es/asn/LogoutSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var LogoutSquareOutlined = function LogoutSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LogoutSquareOutlinedSvg
  }));
};

LogoutSquareOutlined.displayName = 'LogoutSquareOutlined';
export default React.forwardRef(LogoutSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LogoutSquareOutlined.js
// module id = 3071
// module chunks = 0